<template>
    <div class="row">
        <div class="col-12">
            <h4>Selecione os Operadores</h4>
            <div class="row">
                <div class="col-5">
                    <h6 class="text-center">Operadores disponíveis</h6>
                    <select id="avaiableUsers" name="avaiableUsers[]" class="custom-select" multiple style="width: 100%; height: 100%">
                    </select>
                </div>
                <div class="col-2">
                    <h6 class="text-center">Ações</h6>
                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-block btn-primary" @click="transferQueues('right', 'all')"><i class="fas fa-angle-double-right fa-fw"></i></button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-block btn-primary" @click="transferQueues('right', 'selected')"><i class="fas fa-angle-right fa-fw"></i></button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-block btn-primary" @click="transferQueues('left', 'selected')"><i class="fas fa-angle-left fa-fw"></i></button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-block btn-primary" @click="transferQueues('left', 'all')"><i class="fas fa-angle-double-left fa-fw"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <h6 class="text-center">Operadores Selecionados</h6>
                    <select id="selectedUsers" name="selectedUsers[]" class="custom-select" multiple style="width: 100%; height: 100%" :required="isRequired">
                    </select>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
        export default{
            props: {
                required: {
                    type: Boolean,
                    default: true
                }
            },
            data: function() {
                return {
                    groups: [],
                    listExtensions: [],
                    hidden: false,
                    isRequired: this.required
                };
            },
            created() {
                this.getData();
            },
            methods: {
                transferQueues(direction, quantity) {
                    var self = this
                    const element = $(direction == 'right' ? '#avaiableUsers' : '#selectedUsers');
                    const optionList = () => {
                        if(quantity != 'all'){
                            return element.find('option:selected');
                        }else{
                            return element.find('option');
                        }
                    }
                    optionList().prop('selected', true);
    
                    optionList().each(function(i, obj){
                        if(direction == 'right'){
                            self.groups.forEach(group => {
                                if(group.group == $(obj).val()){
                                    group.extensions.forEach(extension => {
                                        self.listExtensions.push(extension);
                                    })
                                }
                            })
                        }else{
                            self.groups.forEach(group => {
                                if(group.group == $(obj).val()){
                                    self.listExtensions = self.listExtensions.filter(function(x) {
                                        return group.extensions.indexOf(x) < 0;
                                    });
                                }
                            })
    
                        }
                    })
                    this.populateExtensions();
    
                    const secondElement = $(direction == 'right' ? '#selectedUsers' : '#avaiableUsers');
                    secondElement.append(optionList());
                    secondElement.trigger('focus');
                },
    
                populateExtensions(){
                    $('#avaiableExtensions, #selectedExtensions').find(`option`).remove();
                    this.listExtensions = this.listExtensions.filter((a, b) => this.listExtensions.indexOf(a) === b)
    
                    this.listExtensions.forEach(extension => {
                        const option = `<option value="${extension}">${extension}</option>`
                        $('#avaiableExtensions').append(option);
                    })
                },
    
                transferExtensions(direction, quantity) {
                    const element = $(direction == 'right' ? '#avaiableExtensions' : '#selectedExtensions');
                    const optionList = () => {
                        if(quantity != 'all'){
                            return element.find('option:selected');
                        }else{
                            return element.find('option');
                        }
                    }
                    optionList().prop('selected', true);
    
                    const secondElement = $(direction == 'right' ? '#selectedExtensions' : '#avaiableExtensions');
                    secondElement.append(optionList());
                    secondElement.trigger('focus');
                },
    
                getData() {
                    var self = this;
                    axios.get(window.location.pathname + "/selects")
                        .then((response) => {
                            const groups = response.data;
                            this.groups = groups;
    
                            groups.forEach(group => {
                                const element = `<option value="${group.id}">${group.name}</option>`
                                $('#avaiableUsers').append(element);
                            })
                        })
                        .catch((error) => {
                            console.error(error);
                        })
                }
            }
        }
    </script>
    